module.exports = {
  WEB_TARGET_PLATFORM: 'web',
  TELEGRAM_TARGET_PLATFORM: 'telegram',
  API_TOKEN_HEADER_KEY: 'x-community-token',
  MVF_TRANSACTION_SESSION_KEY: 'tdl_transid',
  MVF_TRANSACTION_PARAM: 'transaction_id',
  MVF_NETWORK_SRC_VALUE: 'mvftunenetwork',
  MVF_POSTBACK_URL:
    'https://mvfglobal.go2cloud.org/aff_lsr?offer_id=265&transaction_id={{tdl_transid}}',
  UTM_SOURCE_KEY: 'utm_source',
  UTM_SOURCE_VALUE: 'rh_013',
  PARTNER_ID_KEY: 'partner',
  GTM_TAG_ID: 'GTM-TVGMGRXR',
  AUTH_NETWORKS: ['ok', 'mailru', 'yandex', 'vk'],
  CONFIRM_TOKEN_ACTIONS: {
    SIGNUP: 'signup',
    SIGNUPTG: 'signuptg',
    LOGIN: 'login',
    CHANGE_PASSWORD: 'change_password',
  },
  PASSWORD_RECOVERY_REDIRECT_KEY: 'mo-password-recovery-redirect',
  TOKEN_TTL: 180 * 24 * 60 * 60 * 1000, // ms, 180 days
};
